import {useAuthState} from "react-firebase-hooks/auth";

import {auth} from "@/features/api";
import {useCookiesConsent} from "@/features/auth/hooks/useCookiesConsent";
import {useGoogleAnalytics} from "@/features/system/hooks/useGoogleAnalytics";
import {useSetSentryUser} from "@/hooks/useSetSentryUser";

export const AuthLayout = ({children}: {children: React.ReactNode}) => {
  useCookiesConsent();
  useGoogleAnalytics();

  const [user] = useAuthState(auth);
  useSetSentryUser(user);

  return <div className="flex h-dvh flex-col">{children}</div>;
};
